import { render } from "./VehicleActivities.vue?vue&type=template&id=3e91596e"
import script from "./VehicleActivities.vue?vue&type=script&lang=ts"
export * from "./VehicleActivities.vue?vue&type=script&lang=ts"
script.render = render

export default script